import { motion } from "motion/react";
import { Card, CardContent } from "@/src/components/ui/card";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Janine Strydom",
    role: "Human Resource Consultant",
    year: "2012",
    content: "Thank you Chantel from iwantcoaching for being such a great coach and mentor to me. You truly are gifted and it is clear that the Strengthsfinder coaching is your passion in life. Your coaching led to a greater understanding of my talents and you helped me to maximize and focus on the strengths that make me unique. It is one of, if not the best investments I have ever made.",
  },
  {
    name: "Ian Rheeder",
    role: "MD of Markitects",
    year: "2012",
    content: "Johan is loaded with intellectual capital and has a great coaching style. I really recommend the Strengthsfinder approach, it's proven beyond reasonable doubt.",
  },
  {
    name: "Nicci Coertze",
    role: "Individual Client",
    year: "2012",
    content: "Johan is a consummate professional who is able to work with both individuals and teams. He draws upon his knowledge and skills to produce a more productive workplace and helped me to become a better 'me'. I have greater confidence in who I am, and what I am good at. I got more out of that hour and a half than possibly any other comparable time invested in my life.",
  },
  {
    name: "Stefan Coertze",
    role: "Branch Manager, Liberty Life",
    year: "2012",
    content: "Johan is an amazing person, who constantly comes up with new ideas for developing my business. I would recommend his services to anyone who wants to take their business development efforts to the next level. He's taught me and my team a lot about working together effectively and celebrating each other's successes.",
  },
  {
    name: "Freddie Snijman",
    role: "Business Owner",
    year: "2012",
    content: "The positive impact results since 2004 are just ongoing. When you understand who you are and what you want out of life, it must be seen as a precious gift. My life changed day by night very close to the optimum.",
  },
  {
    name: "MIA Management team",
    role: "Media in Africa",
    year: "2012",
    content: "The 12 month program has brought with it a new environment at our office. People are more confident, for the first time they know who they are and where their competencies lie. The positivity that this brings is absolutely contagious.",
  },
  {
    name: "Carol Tuner",
    role: "Senior HR Manager, Group Internal Audit",
    year: "2012",
    content: "I've worked with Eileen on two occasions now and really enjoyed both interactions. Her approach focus on helping me to identify my strengths and use that as departure point. I find this refreshing and exciting.",
  },
  {
    name: "Frans Roos",
    role: "Chief Professional Services Officer, Fundamo",
    year: "2012",
    content: "Eileen's spontaneous character makes her easy to get along with, and she creates an atmosphere where the participant can relax and talk openly. I have personally found much benefit from both the group classes and the individual coaching sessions.",
  },
  {
    name: "Marja Botha van Doorn",
    role: "Personal and Business Coach",
    year: "2010",
    content: "Johan, you have the ability to show me and help me embrace and nurture parts of my own talents that I never consciously knew existed. You're incredibly resourceful and you know how to make the invisible, visible. You're a star!",
  },
  {
    name: "Juanita Doolan",
    role: "Executive Financial Advisor, Liberty Life",
    year: "2013",
    content: "With your help I have been able to stress less, get more organised and yet still achieve my goal of becoming an Executive Financial Advisor. I have regained some sanity back into my life and now spend a lot more time with my husband and daughter.",
  },
  {
    name: "Ryk Croukamp",
    role: "Change Manager, Sasol",
    year: "2011",
    content: "Sonja's level of authenticity is what makes her a fabulous coach. The process was very well managed and she ensured that I felt safe and comfortable during the session. It was a validation of many psychometric tests I've taken.",
  },
  {
    name: "Chris van der Merwe",
    role: "Nedbank Business Banking",
    year: "2012",
    content: "I thoroughly enjoyed the session. Having done numerous assessments before, I did not expect to have so much fun and insight. The way my talents compliment each other was insightful.",
  }
];

export function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-serif mb-4"
          >
            What our <span className="italic text-primary">customers</span> say
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-muted-foreground max-w-2xl mx-auto"
          >
            Real stories from individuals and businesses who have transformed their lives and workplaces through Strengthsfinder coaching.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <Card className="h-full border-none shadow-sm hover:shadow-md transition-all duration-300 bg-background rounded-[2rem] overflow-hidden flex flex-col">
                <CardContent className="p-8 flex-1 flex flex-col">
                  <Quote className="w-8 h-8 text-primary/20 mb-4" />
                  <p className="text-muted-foreground leading-relaxed mb-6 flex-1 italic">
                    "{testimonial.content}"
                  </p>
                  <div className="pt-6 border-t border-primary/5">
                    <h4 className="font-serif font-bold text-lg text-primary">{testimonial.name}</h4>
                    <p className="text-xs uppercase tracking-widest font-semibold text-muted-foreground mt-1">
                      {testimonial.role} {testimonial.year && `(${testimonial.year})`}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
